import { reactive } from "vue";
import Logger from "@/classes/Logger";
import Config from "@/classes/Config";
import UUID from "@/classes/UUID";
import EventManager from "@/classes/EventManager";
import Database from "@/classes/Database";
import Functions from "@/classes/helpers/Functions";
import CryptoCore from "@/classes/CryptoCore";
import WebWorkerFactory from "@/classes/WebWorkerFactory";
import CoreTimer from "@/classes/CoreTimer";
import CryptoHelper from "@/classes/helpers/Crypto";
import Statistics from "@/classes/helpers/Statistics";
import WebSocketClient from "@/classes/WebSocketClient/WebSocketClient";
import Authenticator from "@/classes/Authentication/Authenticator";
import FriendlyTimestamp from "@/classes/helpers/FriendlyTimestamp";
import Ui from "@/classes/Ui";
import Chat from "@/classes/helpers/Chat";

export default class Core
{
    
    constructor( store, router )
    {
        
        if ( !Core.instance ) {
            
            this.store = store
            this.router = router
            
            this.setup()
            
            Core.instance = this
            
        }
        
        return Core.instance
        
    }
    
    setup()
    {

        this.states = reactive( new Map() )
        this.functions = new Functions()
        this.friendlyTimestamp = new FriendlyTimestamp()
        this.uuid = new UUID()
        this.config = new Config()
        this.logger = new Logger( this )
        this.eventManager = new EventManager( this, this.config )
        this.coreTimer = new CoreTimer( this )
        this.cryptoCore = new CryptoCore()
        this.database = new Database( this, this.config )
        
        this.store.commit( 'setDatabase', this.database )
        this.store.commit( 'setEventManager', this.eventManager )
        this.store.commit( 'initStates' )
        
        this.webworkerFactory = new WebWorkerFactory( this )
        this.statistics = new Statistics( this )
        this.cryptoHelper = new CryptoHelper( this )
        this.client = new WebSocketClient( this )
        this.authenticator = new Authenticator( this )
        this.uiClass = new Ui( this )
        this.chat = new Chat( this )
        
        this.logger.injectEventManager( this.eventManager )
        
        this.setState( 'criticalErrors', false )
        
        this.logger.clog( 'Core::setup', 'core set up and ready to go.' )
        
    }
    
    /** core-states **/
    setState( key, value )
    {
        
        let state  = this.states.get( key ),
            change = undefined !== state && value !== state
        
        this.states.set( key, value )
        
        if( change )
        {
            this.eventManager.dispatch( 'on-core-state-change-' + key, value )
        }
        
    }
    
    getState( key )
    {
        return this.states.get( key )
    }
    
    deleteState( key )
    {
        delete this.states.delete( key )
    }

    f()
    {
        return this.functions
    }
    
    s()
    {
        return this.statistics
    }
    
    ui()
    {
        return this.uiClass
    }
    
    ww()
    {
        return this.webworkerFactory
    }
    
    getAuthenticator()
    {
        return this.authenticator
    }
    
    getClient()
    {
        return this.client
    }
    
    getFriendlyTimestamp()
    {
        return this.friendlyTimestamp
    }
    
    getDatabase()
    {
        return this.database
    }
    
    getCryptoCore()
    {
        return this.cryptoCore
    }
    getCryptoHelper()
    {
        return this.cryptoHelper
    }
    
    getCoreTimer()
    {
        return this.coreTimer
    }
    
    getStore()
    {
        return this.store
    }
    
    getEventManager()
    {
        return this.eventManager
    }
    
    getUuid()
    {
        return this.uuid
    }
    
    getConfig()
    {
        return this.config
    }
    
    getLogger()
    {
        return this.logger
    }
    
    getRouter()
    {
        return this.router
    }
    
    getChat()
    {
        return this.chat
    }
    
}